import debounce from 'lodash.debounce';
const formRegisterMediaSections = document.querySelectorAll(
    '.form-section__register-media'
);

if (formRegisterMediaSections) {
    const handleClauseClasses = (clauseElement, triggerButton, isRemove) => {
        if (isRemove) {
            clauseElement.classList.remove('hide');
            triggerButton.classList.remove('show');
        } else {
            clauseElement.classList.add('hide');
            triggerButton.classList.add('show');
        }
    };

    const handleClauseButtonClick = (clauseElement, triggerButton) => {
        const dataShowed = triggerButton.getAttribute('data-showed');
        if (dataShowed === 'false') {
            clauseElement.classList.remove('hide');
            triggerButton.textContent = triggerButton.getAttribute('data-hide');
            triggerButton.setAttribute('data-showed', 'true');
        } else {
            clauseElement.classList.add('hide');
            triggerButton.textContent = triggerButton.getAttribute('data-show');
            triggerButton.setAttribute('data-showed', 'false');
        }
    };

    const handleClause = clauseElement => {
        const fakeClause = clauseElement.parentElement.querySelector(
            '.form-checkbox__label--fake'
        );
        const fakeClauseHeight = fakeClause.offsetHeight;
        const lineHeight = 24;
        const linesTotal = fakeClauseHeight / lineHeight;
        const windowWidth = window.innerWidth;
        const triggerButton =
            clauseElement.parentElement.querySelector('.js-show-more');

        clauseElement.classList.add('hide');
        triggerButton.textContent = triggerButton.getAttribute('data-show');
        triggerButton.setAttribute('data-showed', 'false');

        if (windowWidth <= 767.98) {
            if (linesTotal > 2) {
                handleClauseClasses(clauseElement, triggerButton, false);
            } else {
                handleClauseClasses(clauseElement, triggerButton, true);
            }
        } else {
            if (linesTotal > 3) {
                handleClauseClasses(clauseElement, triggerButton, false);
            } else {
                handleClauseClasses(clauseElement, triggerButton, true);
            }
        }
        triggerButton.addEventListener('click', () =>
            handleClauseButtonClick(clauseElement, triggerButton)
        );
    };

    const handleSubmitForm = async (e, form, token) => {
        e.preventDefault();
        const postId = form.getAttribute('data-post-id');
        const successMessage = form.getAttribute('data-thank-text');
        const alertWrapper = form.querySelector('.form-alert');
        const errorElements = form.querySelectorAll('.error');
        const formButton = form.querySelector(
            '.form-register-media__submit-button'
        );
        const loaderWrapper = form.querySelector(
            '.form-register-media__loader'
        );
        const outputWrapper = form.querySelector(".form__output-wrapper");

        if (outputWrapper) {
            outputWrapper.classList.remove("error");
            outputWrapper.classList.remove("success");
        }

        formButton.classList.add('button--disabled');
        loaderWrapper.classList.add('show');

        if (errorElements)
            errorElements.forEach(el => el.classList.remove('error'));

        try {
            const formData = new FormData(form);
            formData.set('postId', postId);
            formData.set('successMessage', successMessage);
            formData.set('token', token);
            const res = await fetch(ajax.url, {
                body: formData,
                method: 'POST',
            });
            if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
            }

            const responseJson = await res.json();
            const { response, status, status_name } = responseJson.data;

            formButton.classList.remove('button--disabled');
            loaderWrapper.classList.remove('show');

            const globalErrors = response.globalErrors
                ? response.globalErrors
                : false;
            const fieldErrors = response.fieldErrors
                ? response.fieldErrors
                : false;
            let message = '';

            if (globalErrors || fieldErrors) {
                if (globalErrors) {
                    globalErrors.forEach(error => {
                        message = message + error.message + '\r\n' + ' ';
                    });
                }
                if (fieldErrors) {
                    for (const [key, value] of Object.entries(fieldErrors)) {
                        const invalidElement = form.querySelector(
                            `[name='${key}']`
                        );
                        invalidElement.parentElement.parentElement.classList.add(
                            'error'
                        );
                        message = message + '\r\n' + value[0].message;
                    }
                }
            } else {
                message = response;
            }

            if (outputWrapper) {
                outputWrapper.classList.add(status);
                outputWrapper.innerHTML = message;
            }

            if (status === 'success') {
                form.reset();
                const filledElements = form.querySelectorAll('.filled');
                filledElements.forEach(el => el.classList.remove('filled'));
            }
        } catch (error) {
            console.log(error);
        }
    };

    formRegisterMediaSections.forEach(section => {
        const form = section.querySelector('form');
        const clauseTexts = section.querySelectorAll(
            '.form-checkbox__label--register'
        );

        if (clauseTexts) {
            clauseTexts.forEach((clause, e) => {
                handleClause(clause);
            });
        }

        form.addEventListener('submit', e => {
            e.preventDefault();
        });
        form.addEventListener(
            'submit',
            debounce(e => {
                const recaptchaSiteKey =
                    form.querySelector(`[name='site-key']`).value;
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(recaptchaSiteKey, { action: 'submit' })
                        .then(function (token) {
                            handleSubmitForm(e, form, token);
                        });
                });
            }, 300)
        );
    });
}
